import { GetAuthToken } from '../../contexts/AuthContext';
import { IUserFull, IEditableUserAttributes } from '../../interfaces/rutilus/user';

import { returnJsonOrThrow, put } from './shared';

export const updateUserProfile = async (
  attributes: Partial<IEditableUserAttributes>,
  getAuthToken: GetAuthToken,
  headers?: object,
): Promise<IUserFull> =>
  put('/me', getAuthToken, attributes, headers).then(async r => returnJsonOrThrow<IUserFull>(r));
